import { Component, OnInit, HostListener } from '@angular/core';
import { PlaylistComponent } from './components/oneroll-player/playlist/playlist.component';
import { environment } from 'src/environments/environment';
import { VideoService } from './services/video.service';
import { BaseService } from './services/base.service';
import { GaService } from './services/ga.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'oneroll-player-web-app';

  success: boolean;
  response: any;
  responsible: boolean;
  currentHeight: number;
  enable: boolean = true;
  lpEnable: boolean = false;
  error: string;

  ready: boolean = false;

  constructor(
    public videoService:VideoService,
    public baseService:BaseService,
    private gaService:GaService,
  ){

  }

  async ngOnInit(){

    // Password Test
    // const response = await this.videoService.password("cbBe3ko65u9W", "");
    // window.orpv = JSON.stringify(response);

    this.success = true;
    this.response = null;
    this.responsible = false;
    this.currentHeight = 0;
  
    this.response = JSON.parse(orpv);

    console.log(this.response);
    
    if(this.response.success === false){
      this.success = false;
      this.error = "この動画は表示できません";
      return;
    }

    if(this.response.enable === false){
      this.enable = false;
      this.error = "この動画は表示できません";
      return;
    }

    let htmlElement = document.getElementsByTagName('html').item(0);
    htmlElement.setAttribute("id", "html-root");

    if(this.response.resp){
      htmlElement.classList.add('responsible');
    }

    const responsible = document.getElementById("html-root").classList.contains("responsible");
    if(responsible){
      this.responsible = true;
    }

    if(this.response.lp){
      this.lpEnable = true;
      this.responsible = true;
      htmlElement.classList.add('responsible');
      htmlElement.classList.add('lp');
    }

    this.initTrack();

    // 親windowとのMessageを初期化
    // this.baseService.sendMessageToOuterFrame(this.response.playlist.videoHashPublic);

    setTimeout(() => {
      console.log("ready");
      this.ready = true;

      this.initGa();      
    }, 500);

  }

  initTrack(){

    if(this.response.isPreviewMode){
      return;
    }

    if(! this.response.playlist.gId || ! this.response.playlist.cIId){
      return;
    }
    let otGId = this.response.playlist.gId;
    let otCIId = this.response.playlist.cIId;

    if(! otGId || ! otCIId){
      return;
    }

    if(window.onerollTrack){
      // track設定
      var iframeTag = document.createElement('iframe');
      iframeTag.src = environment.trackEndPoint + '/iframe.html' + '?otGId=' + otGId + '&otCIId=' + otCIId;
      iframeTag.setAttribute('style', 'width:0;height:0;border:0;display:block;');
      iframeTag.setAttribute('width', "0");
      iframeTag.setAttribute('height', "0");
      var bodyTag = document.getElementsByTagName('body').item(0);
      bodyTag.appendChild(iframeTag);

      window.onerollTrack.init("video", otGId, otCIId);
    }
  }

  initGa(){
    if(this.response.playlist.gaId){
      // initすると自動でgaタグがbodyに作成される
      this.gaService.init(this.response.playlist.gaId);
    }
  }
  
//   sendHeight(){
//     if(! this.response.playlist.videoHashPublic){
//       return;
//     }
//     if(document.getElementById("app-root").offsetHeight < 90){
//       return;
//     }
//     this.currentHeight = document.getElementById("app-root").offsetHeight;

//     let json = {
//       id: "oneroll-" + this.response.playlist.videoHashPublic,
//       height: this.currentHeight,
// //        height: document.getElementById("app").clientHeight
//     };
//     console.log(json);
//     window.parent.postMessage(JSON.stringify(json), "*");
//   }

  @HostListener('window:resize', ['$event'])
  onResize(event){
    if(this.baseService.isDisableResizeEvent){
      return;
    }
    console.log("onResize");
    this.baseService.sendHeightToOuterFrame(this.response.playlist.videoHashPublic);
  }
}
